import wave from "@mittwald/flow-styles/dist/wave.svg";
import styled from "styled-components";
import { Box } from "../../Box";
export const Wave = styled(Box) `
  mask-image: url(${wave});
  mask-size: 100% 100%;
  background-color: #00205c;
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiV2F2ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01pdHR3YWxkV2F2ZS9zdHlsZWQvV2F2ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLElBQUksTUFBTSxxQ0FBcUMsQ0FBQztBQUN2RCxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUN2QyxPQUFPLEVBQUUsR0FBRyxFQUFFLE1BQU0sV0FBVyxDQUFDO0FBRWhDLE1BQU0sQ0FBQyxNQUFNLElBQUksR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFDLENBQUE7b0JBQ1gsSUFBSTs7O0NBR3ZCLENBQUMifQ==